import { useDispatch, connect } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { getActiveLocale } from '@openclassrooms/translations';
import { RouteChangeListener } from '@openclassrooms/routing';
import LocalizationProvider from '@classify/react-core-components/LocalizationProvider';

import { actions, selectors } from 'Modules/errors';
import { ScrollToTop } from 'Modules/scroll';
import { RolesProvider } from 'Modules/roles';
import ProtectedFileDownloadHandler from 'Modules/auth/components/ProtectedFileDownloadHandler';

import onRouteChange from '../../services/onRouteChange';
import { routeChanged } from '../../actions';

import Routing from '../Routing';

const Webapp = ({ dismissGlobalError = () => {}, globalError = null }) => {
  const dispatch = useDispatch();

  const routeChangeHandler = () => {
    dismissGlobalError();
    onRouteChange();
    dispatch(routeChanged());
  };

  const activeLocale = getActiveLocale();
  const [, basename] = document.location.pathname.match(/^\/(.*?)\//);
  return (
    <LocalizationProvider locale={activeLocale}>
      <RolesProvider>
        <Router basename={`/${basename}`}>
          <ProtectedFileDownloadHandler>
            <ScrollToTop>
              <Routing globalError={globalError} />
              <RouteChangeListener shouldFireOnInit onChange={routeChangeHandler} />
            </ScrollToTop>
          </ProtectedFileDownloadHandler>
        </Router>
      </RolesProvider>
    </LocalizationProvider>
  );
};

const mapStateToProps = (state) => ({
  globalError: selectors.globalError.get(state),
});

const mapDispatchToProps = (dispatch) => ({
  dismissGlobalError() {
    return dispatch(actions.dismissGlobalError());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Webapp);
